module.exports = __webpack_public_path__ + "media/application/images/svgs/pawnbroker_slider-background-3a5040641461bb6882f6ba2d27d2447e.svg";